import { ReactElement } from "react";
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { IoChevronDown, IoSettingsSharp } from "react-icons/io5";

interface MenuItemData {
  label: string;
  onSelect: () => void;
  testId?: string;
}

interface SettingsButtonProps {
  menuItems: MenuItemData[];
}

export function SettingsButton({
  menuItems,
}: Readonly<SettingsButtonProps>): ReactElement {
  return (
    <Menu>
      <MenuButton
        as={Button}
        data-testid="settings-menu-button"
        margin="10px auto"
        leftIcon={<IoSettingsSharp />}
        variant="ghost"
        borderRadius={0}
        bg="primary.bg_lv1"
        _hover={{ backgroundColor: "primary.theme_lv3" }}
        _active={{ backgroundColor: "primary.theme_lv3" }}
        minWidth="70px"
      >
        <Flex alignItems="center" columnGap={2}>
          <IoChevronDown />
        </Flex>
      </MenuButton>
      <MenuList minWidth="70px" borderRadius={0} backgroundColor="common.base">
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            data-testid={item.testId}
            color="text.subtext"
            _focus={{ backgroundColor: "primary.bg_lv1" }}
            onClick={item.onSelect}
          >
            {item.label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
